module.exports = __webpack_public_path__ + "static/media/cta_screenshot_iPhone12Pro.617275a8.png";